module.exports = __webpack_public_path__ + "static/media/2.a5f4eb72.png";